export default __webpack_public_path__ + "media/images/icon_done-dba357bfbba455428787fefc655ce120.svg";